import {
  addColumns,
  schemaMigrations,
} from "@nozbe/watermelondb/Schema/migrations";

// Upgrades the database already on each device instead of wiping it, so
// changes made offline are never lost when the app updates.
export default schemaMigrations({
  migrations: [
    {
      toVersion: 2,
      steps: [
        addColumns({
          table: "proposals",
          columns: [{ name: "archived_at", type: "number", isOptional: true }],
        }),
      ],
    },
  ],
});
